"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPOGRAPHY = void 0;
exports.TYPOGRAPHY = {
    defaultProps: {
        variantMapping: {
            subtitle1: 'p',
            subtitle2: 'p',
            subtitle3: 'p',
            subtitle4: 'p',
            body1: 'p',
            body2: 'p',
            inherit: 'p',
        },
    },
};
